import { render } from "./Location.vue?vue&type=template&id=8da88b80&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"

import "./Location.vue?vue&type=style&index=0&id=8da88b80&scoped=true&lang=css"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da88b80"]])

export default __exports__